import hydrate from 'widget/hydrate';
import PodcastProfile from './PodcastProfile';
import { ComponentProps, ComponentType } from 'react';

hydrate<ComponentProps<ComponentType<any>>>(PodcastProfile);
